import DynamicElement from './DynamicElement';
import account from './account';
import { trackEvent } from '../util/tracking';
import EventDispatcher from '../util/EventDispatcher';
import { isLocalStorageAvailable } from '../util/localStorage';

// Load known favorites from local storage for speedy render
var favorites = [];
var favoritesNumber = document.querySelector('.fav-nr-large');
var eventDispatcher = new EventDispatcher();

if (isLocalStorageAvailable) {
  favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
}

var hearts = DynamicElement({
  query: '.favorite-heart-js',
  render: (id, el) => {
    if (
      favorites.indexOf(id) !== -1 &&
      !el.classList.contains('favorite-active')
    ) {
      el.classList.add('favorite-active');
      el.querySelector('.cece-icon').classList.add('fill');

      if (el.getAttribute('data-bs-toggle') === 'tooltip') {
        disposeTooltip(el);
        el.setAttribute(
          'title',
          favoritesNumber.getAttribute('data-title-is-favorite')
        );
        new window.bootstrap.Tooltip(el, {
          title: favoritesNumber.getAttribute('data-title-is-favorite'),
        });
      }
    } else if (
      favorites.indexOf(id) === -1 &&
      el.classList.contains('favorite-active')
    ) {
      el.classList.remove('favorite-active');
      el.querySelector('.cece-icon').classList.remove('fill');

      if (el.getAttribute('data-bs-toggle') === 'tooltip') {
        disposeTooltip(el);
        el.setAttribute(
          'title',
          favoritesNumber.getAttribute('data-title-not-favorite')
        );
        new window.bootstrap.Tooltip(el, {
          title: favoritesNumber.getAttribute('data-title-not-favorite'),
        });
      }
    }
  },
});

var totalCount = DynamicElement({
  query: '.fav-nr-large',
  render: (id, el) => {
    if (account.isAuthenticated()) {
      el.classList.remove('d-none');
      el.textContent = favorites.length;
    } else {
      el.classList.add('d-none');
    }
  },
});

function disposeTooltip(el) {
  const tooltip = window.bootstrap.Tooltip.getInstance(el);
  if (tooltip) {
    tooltip.dispose();
  }
  el.removeAttribute('title');
  el.removeAttribute('data-original-title');
}

function init() {
  // Whenever account status changes, make sure to update favorites
  account.addEventListener('update', function ({ detail: profile }) {
    if (profile && profile.userId) {
      update(profile.favorites);
    } else {
      reset();
    }
  });

  // If account is not authenticated, don't do anything
  if (!account.isAuthenticated()) {
    return;
  }

  hearts.render();
  totalCount.render();
}

function save() {
  // Remove duplicated
  favorites = favorites.filter((id, index) => favorites.indexOf(id) === index);
  // Save as JSON string in local storage
  localStorage.setItem('favorites', JSON.stringify(favorites));
}

function update(_favorites) {
  // Check if the incoming favorites are exactly the same as what we have now
  // if so don't proceed with updating the page and local storage
  var diff = _favorites.filter(f => favorites.indexOf(f) === -1);
  if (diff.length === 0 && _favorites.length === favorites.length) return;

  favorites = _favorites;
  save();

  hearts.render();
  totalCount.render();
}

function isFavorited(productId) {
  return favorites.indexOf(productId) !== -1;
}

async function toggleFavorite(e, productId, storeName, productTitle) {
  if (e) {
    e.preventDefault();
  }

  // Show login modal when visitor is not logged in
  if (!account.isAuthenticated()) {
    window.toLogin(productId);
    return;
  }

  // Update state
  if (isFavorited(productId))
    favorites = favorites.filter(id => id != productId);
  else favorites.push(productId);

  eventDispatcher.dispatchEvent(
    new CustomEvent('update', { detail: [...favorites] })
  );

  // Render
  hearts.render(productId);
  totalCount.render();
  save();

  // Update server
  try {
    const json = await fetch(
      window.getBaseUrl() + '/accounts/change_favorite/' + productId + '/',
      {
        method: 'POST',
        body: productId,
      }
    );
    const { favorites } = await json.json();
    update(favorites || []);

    // Tracking
    trackEvent('Favorite', storeName, productTitle);
  } catch (err) {
    console.error(`Error favoriting product with id '${productId}: ${err}`);
  }
}

function getFavorites() {
  return [...favorites];
}

function addEventListener(type, listener) {
  eventDispatcher.addEventListener(type, listener);
}

function reset() {
  localStorage.removeItem('favorites');
  favorites = [];
  hearts.render();
  totalCount.render();
}

document.addEventListener('DOMContentLoaded', function () {
  init();
});

export default {
  addEventListener,
  isFavorited,
  getFavorites,
  toggleFavorite,
  render: id => hearts.render(id),
  refresh: () => {
    hearts.refresh();
    hearts.render();
  },
  update,
  reset,
};
